import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
//import jsPDF from "jspdf";
//import autoTable from "jspdf-autotable";
import html2pdf from "html2pdf.js";



const PaidPayments = () => {
  const [paid, setPaid] = useState([]);
  const [filterName, setFilterName] = useState("");
  const [filterRoom, setFilterRoom] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const getPaidPayments = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_WEB_SERVICES_URL}/admin/get-paid-payments`,
        {
          params: { page, searchName: filterName, searchRoom: filterRoom },
          withCredentials: true,
        }
      );

      if (res.data.status) {
        setPaid(res.data.paid || []);
        setTotalPages(res.data.pagination?.totalPages || 1);
      } else {
        setPaid([]);
        setTotalPages(1);
      }
    } catch (err) {
      console.error("Error fetching payments:", err);
      setPaid([]);
      setTotalPages(1);
    }
  };

  useEffect(() => {
    getPaidPayments();
  }, [page, filterName, filterRoom]);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    return new Date(dateString).toLocaleDateString();
  };

  const formatDateRange = (startDate, monthsPaid) => {
    const start = new Date(startDate);
    const end = new Date(start);
    end.setMonth(end.getMonth() + monthsPaid); // add months

    const format = (date) =>
  date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short", // <-- changes "11" to "Nov"
    day: "2-digit",
  });

return `(${format(start)} - ${format(end)})`;
  };

  // 🔹 Print handler
 const handlePrint = (payment) => {
  const invoiceHtml = `
    <div style="font-family: Arial, sans-serif; margin: 60px;">
      <div style="display: flex; justify-content: space-between;">
        <div>
          <strong style="font-size: 16px;">BLESSED BUILDERS SOBER LIVING HOMES</strong><br/>
         2700 State St. Ste F-6<br/>
         Bismarck ND 58503<br/>
         PH: 701-751-0318
        </div>
        <div style="font-size: 24px; font-weight: bold;line-height:1">
        INVOICE
         <br/><span style="font-size: 12px; font-weight: bold;">REF#: ${payment.reference_no}</span>
        </div>
         
       
      </div>

      <div style="margin-top: 60px;">

      <table style="border-collapse:collapse;margin-left:3pt;width:100%;" cellspacing="0">
      <tbody>
      <tr style="height:52pt">
      <td rowspan="2" style="width:32%;border-top:solid 5pt black;vertical-align:top;font-size:16px;">
      <div style="font-size:20px;margin-top:10px;">BILL TO:</div>
      <p>
          ${payment.name || ""}<br/>
          ${payment.address || ""},
          ${payment.city || ""} ${payment.state || ""} ${payment.zip || ""} ${payment.country || ""}
        </p>
      
      </td>
      <td style="text-align:center;width:17%;border: solid black 2pt;border-left:solid black 3pt;border-top:solid 5pt black;border-bottom:black 3pt solid;font-size:13px;">
         <p style="padding-top: 10pt;">INVOICE ID</p>
        <p>#${String(payment.payment_id).padStart(6, "0")}</p>
        </td>
     <td style="text-align:center;width:17%;border: solid black 2pt;border-top:solid 5pt black;border-bottom:black 3pt solid;font-size:13px;">
          <p style="padding-top: 10pt;">INVOICE DATE</p>
           <p>${new Date(payment.created_at).toLocaleDateString()}</p>
      </td>
       <td style="text-align:center;width:17%;border: solid black 2pt;border-top:solid 5pt black;border-bottom:black 3pt solid;font-size:13px;">
          <p style="padding-top: 10pt;">DUE DATE</p>
          <p >${new Date(payment.created_at).toLocaleDateString()}</p>
        </td>
       <td style="text-align:center;width:17%;border: solid black 2pt;border-top:solid 5pt black;border-right:solid 3pt black;border-bottom:black 3pt solid;font-size:13px;background-color:#DDDDDD;">
           <p style="padding-top: 10pt;">BALANCE</p>
            <p  >$${Number(payment.amount).toFixed(2)}</p>
      </td>
      </tr>
      <tr>
      <td>&nbsp;</td>
       <td>&nbsp;</td>
       <td>&nbsp;</td>
       <td>&nbsp;</td>
       
      </tr>
      </tbody>
      </table>


       
      </div>

      <table style="width: 100%; border-collapse: collapse; margin-top: 20px;">
        <thead>
          <tr>
            <th style="border: 1px solid #ddd; padding: 8px; background: #f2f2f2;">Date</th>
            <th style="border: 1px solid #ddd; padding: 8px; background: #f2f2f2;">Unit</th>
            <th style="border: 1px solid #ddd; padding: 8px; background: #f2f2f2;">Item</th>
            <th style="border: 1px solid #ddd; padding: 8px; background: #f2f2f2;">Rate</th>
            <th style="border: 1px solid #ddd; padding: 8px; background: #f2f2f2;">Discount</th>
            <th style="border: 1px solid #ddd; padding: 8px; background: #f2f2f2;">Total</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="border: 1px solid #ddd; padding: 8px;">${new Date(payment.created_at).toLocaleDateString()}</td>
            <td style="border: 1px solid #ddd; padding: 8px;">${payment.room_no || "-"}</td>
            <td style="border: 1px solid #ddd; padding: 8px;">
              ${payment.bedtypename || ""} ${payment.property_name || ""} 
              ${payment.months_paid > 0 ? `(${new Date(payment.created_at).toLocaleDateString()} - ${new Date(new Date(payment.created_at).setMonth(new Date(payment.created_at).getMonth() + payment.months_paid)).toLocaleDateString()})` : ""}
            </td>
            <td style="border: 1px solid #ddd; padding: 8px;">$${Number(payment.amount).toFixed(2)}</td>
            <td style="border: 1px solid #ddd; padding: 8px;">$0.00</td>
            <td style="border: 1px solid #ddd; padding: 8px;">$${Number(payment.amount).toFixed(2)}</td>
          </tr>
        </tbody>
      </table>

     ${payment.is_recurring === 1 ? `
  <div style="margin-top: 15px; font-size: 12px;">
    You are signed up for autopay. You will automatically be charged on 
    ${new Date(new Date(payment.created_at).setMonth(new Date(payment.created_at).getMonth() + 1)).toLocaleDateString()} 
    via ${payment.method || "card"}.
  </div>
` : ""}

      <div style="margin-top: 20px; text-align: right;">
        <table style="float: right;">
          <tr><td><strong>Subtotal:</strong></td><td style="padding-left: 10px;">$${Number(payment.amount).toFixed(2)}</td></tr>
          <tr><td><strong>Total:</strong></td><td style="padding-left: 10px;">$${Number(payment.amount).toFixed(2)}</td></tr>
          <tr><td><strong>Payments Received:</strong></td><td style="padding-left: 10px;">$${Number(payment.amount).toFixed(2)}</td></tr>
        </table>
      </div>

      <div style="margin-top: 50px;">
        Signature: _______________________
      </div>
    </div>
  `;

  const opt = {
    margin: [1, 0.5, 1, 0.5], 
    filename:     `invoice_${payment.payment_id}.pdf`,
    image:        { type: "jpeg", quality: 0.98 },
    html2canvas:  { scale: 6 },
jsPDF: { unit: "mm", format: "a4", orientation: "portrait" }
  };

  html2pdf().from(invoiceHtml).set(opt).save();
};


  // 🔹 Email handler
  // 🔹 Email handler with SweetAlert
  const handleEmail = async (payment) => {
    const { value: email } = await Swal.fire({
      title: "Send Invoice",
      input: "email",
      inputLabel: "Recipient Email",
      inputValue: payment.email || "",
      inputPlaceholder: "Enter email address",
      showCancelButton: true,
      confirmButtonText: "Send",
      cancelButtonText: "Cancel",
      inputValidator: (value) => {
        if (!value) return "Email is required!";
        // very basic validation
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) return "Invalid email format!";
      },
    });

    if (email) {
      try {
        await axios.post(
          `${process.env.REACT_APP_WEB_SERVICES_URL}/admin/send-payment-email`,
          { paymentId: payment.payment_id, email },
          { withCredentials: true }
        );
        Swal.fire("✅ Success", "Invoice email sent successfully!", "success");
      } catch (err) {
        console.error("Error sending invoice email:", err);
        Swal.fire("❌ Error", "Failed to send invoice email.", "error");
      }
    }
  };



  return (
    <div>
      {/* 🔹 Filters */}
      <div className="d-flex gap-2 mb-2 ">
        <input
          type="text"
          placeholder="Filter by name"
          className="form-control"
          value={filterName}
          onChange={(e) => setFilterName(e.target.value)}
        />
        <input
          type="text"
          placeholder="Filter by room"
          className="form-control"
          value={filterRoom}
          onChange={(e) => setFilterRoom(e.target.value)}
        />
      </div>

      {/* 🔹 Table */}
      <table className="table table-bordered table-hover">
        <thead className="table-success">
          <tr>
            <th>Guest</th>
            <th>Payment Date</th>
            <th>Method</th>
            <th>Room</th>
            <th>Total Amount</th>
            <th>Status</th>
            <th>Actions</th> {/* NEW column */}
          </tr>
        </thead>
        <tbody>
          {paid.length === 0 ? (
            <tr>
              <td colSpan="7" className="text-center">
                No records found
              </td>
            </tr>
          ) : (
            paid.map((item) => (
              <tr key={item.id}>
                <td>{item.name}</td>
                <td>{formatDate(item.created_at)}</td>
                <td className="text-capitalize">{item.method}</td>
                <td>
                  {item.bedtypename} {item.room_no} {item.property_name} <br />
                  {item.months_paid > 0 ? formatDateRange(item.created_at, item.months_paid) : "-"}
                </td>
                <td>
                  { `$${Number(item.amount).toFixed(2)}`}
                </td>
                <td className="text-capitalize">
                  <span
                    className={`badge ${item.status === "succeeded"
                        ? "bg-success"
                        : "bg-warning text-dark"
                      }`}
                  >
                    {item.status}
                  </span>
                </td>
                <td>
                  <button
                    className="btn btn-sm btn-outline-primary me-2"
                    onClick={() => handlePrint(item)}
                  >
                    🖨 Print
                  </button>
                  <button
                    className="btn btn-sm btn-outline-success"
                    onClick={() => handleEmail(item)}
                  >
                    ✉ Email
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {/* 🔹 Pagination */}
      <div className="d-flex justify-content-between">
        <button
          className="btn btn-outline-primary"
          disabled={page <= 1}
          onClick={() => setPage(page - 1)}
        >
          Previous
        </button>
        <span>
          Page {page} of {totalPages}
        </span>
        <button
          className="btn btn-outline-primary"
          disabled={page >= totalPages}
          onClick={() => setPage(page + 1)}
        >
          Next
        </button>
      </div>

      
    </div>



  );
};

export default PaidPayments;
